import React from 'react';
import { formatDate } from '../utils/dateUtils';
import {
    ArchivedSection,
    ArchivedCard,
    CardTitle,
    CardMeta,
    SectionTitle,
    EmptyMessage
} from '../styles/ArchivedItems.styles';

const ArchivedItems = ({ archivedCards = [], onCardClick }) => {
    const renderArchivedCards = () => {
        if (archivedCards.length === 0) {
            return <EmptyMessage>No archived cards</EmptyMessage>;
        }

        return archivedCards.map(card => (
            <ArchivedCard
                key={card.id}
                onClick={() => onCardClick(card)}
            >
                <CardTitle>{card.title}</CardTitle>
                <CardMeta>
                    Archived {new Date(card.archivedAt).toLocaleDateString()}
                </CardMeta>
            </ArchivedCard>
        ));
    };

    return (
        <ArchivedSection>
            <SectionTitle>Archived Cards</SectionTitle>
            {renderArchivedCards()}
        </ArchivedSection>
    );
};

export default ArchivedItems;
